/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'people.menu.renotify.flag.description': 'Vi sender alle en e-mail med en påmindelse. Det kan tage op til et minut.',
  'people.menu.renotify.flag.description.confluence': 'Påmind teammedlemmer',
  'people.menu.renotify.flag.title': 'Sender påmindelser',
  'people.menu.renotify.flag.title.confluence': 'Sender invitations-e-mail igen',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} person har ikke accepteret sin invitation til {product}. Se, hvem der mangler, og send dem en påmindelse.} other {{userCount,number} personer har ikke accepteret deres invitation til {product}. Se, hvem der mangler, og send dem en påmindelse.}}',
  'people.menu.renotify.menu.description.confluence':
    'Nogle personer har ikke accepteret deres invitation til Confluence. Se, hvem der mangler, og send dem en påmindelse.',
  'people.menu.renotify.menu.dismiss': 'Luk',
  'people.menu.renotify.menu.dismiss.confluence': 'Ikke nu',
  'people.menu.renotify.menu.remind': 'Påmind teammedlemmer',
  'people.menu.renotify.menu.remind.confluence': 'Påmind teammedlemmer',
  'people.menu.renotify.menu.title': 'Er alle med?',
  'people.menu.renotify.modal.copied': 'Linket blev kopieret',
  'people.menu.renotify.modal.copy': 'Kopiér invitationslink',
  'people.menu.renotify.modal.description':
    'Vi kan sende en e-mail med en påmindelse til de manglende medlemmer, eller også kan du selv dele invitationslinket.',
  'people.menu.renotify.modal.description.confluence':
    'Send invitations-e-mailen igen, eller kopiér og del invitationslinket.',
  'people.menu.renotify.modal.dismiss': 'Annuller',
  'people.menu.renotify.modal.resend': 'Send påmindelse',
  'people.menu.renotify.modal.resend.confluence': 'Send invitation igen',
  'people.menu.renotify.modal.title': 'Send påmindelser til manglende medlemmer',
  'people.menu.renotify.modal.title.confluence': 'Påmind manglende teammedlemmer',
  'ptc.pm.collaborators.title': 'Dine samarbejdspartnere',
  'ptc.pm.error-heading': 'Noget gik galt',
  'ptc.pm.error-image-alt-text':
    'En robot, der er gået i stykker, og en masse mennesker, der har travlt med at reparere den.',
  'ptc.pm.error-text': 'Vi holder øje med disse fejl, men kontakt os endelig, hvis det ikke hjælper at opdatere siden',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
  'ptc.pm.people': 'Personer',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Vis din profil',
  'ptc.pm.your-teams.title': 'Dine teams',
};
